import request from '@/utils/request'

let Purchase_insurance_recordApi = {

  /*购保记录列表*/
  list(data) {
    return request._post('/shop/plus.purchase_insurance_record.Index/index', data);
},
/*添加购保记录*/
add(data) {
    return request._post('/shop/plus.purchase_insurance_record.Index/add', data);
},
/*修改购保记录*/
edit(data) {
    return request._post('/shop/plus.purchase_insurance_record.Index/edit', data);
},
/*删除购保记录*/
del(data) {
    return request._post('/shop/plus.purchase_insurance_record.Index/del', data);
},
/*购保记录详情*/
detail(data) {
  return request._post('/shop/plus.purchase_insurance_record.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.purchase_insurance_record.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.purchase_insurance_record.Setting/getSetting', data, errorback);
    },
}
export default Purchase_insurance_recordApi;



// WEBPACK FOOTER //
// ./src/api/purchase_insurance_record.js